module.exports = __webpack_public_path__ + "assets/•••.29e2f81c.svg";